import React from 'react';

const mainColor = '#4299e1';

const SvgAudio = () => (
  <svg
    id="a9556c1d-039e-450d-9846-bdcfe1beae94"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="888"
    height="690.60514"
    viewBox="0 0 888 690.60514"
    style={{ width: '100%', height: '100%' }}
  >
    <title>listening</title>
    <path
      d="M1015.78968,774.15317l23.04878-33.40341-23.04592,37.02676.00179,3.78986q-2.48-.01084-4.91031-.14151l1.70746-48.69537-.02626-.37614.04231-.07211.16272-4.6014L988.40346,691.3775l24.37886,32.85715.07622.97392,1.28981-36.79126-20.97159-37.58574,21.11015,31.12152.69044-76.24578.00352-.25376.0043.24966.701,60.10687,19.814-24.17433-19.81224,29.3517.03116,32.92314,18.349-31.91125-18.341,36.75156.01758,18.30692,26.66072-44.43878-26.6579,50.82525Z"
      transform="translate(-156 -104.69743)"
      fill="#d0cde1"
    />
    <path
      d="M323.64635,764.40824l66.40642-95.04708L323.594,774.76l-.0581,10.82744q-7.08493-.07234-14.02612-.4862l5.69066-139.09144-.06875-1.07505.12209-.2053.54164-13.14322L246.78667,527.46585l69.10075,94.27781.20153,2.7837,4.29882-105.089L261.10026,411.70807l59.79122,89.26466,3.24479-217.81836.0143-.72492.0081.71333.99978,171.73363,57.011-68.73407L325.07723,469.6679,324.6169,563.728l52.9544-90.86246L324.55888,577.55659l-.25522,52.30215L401.21333,503.3445l-77.0082,144.76006Z"
      transform="translate(-156 -104.69743)"
      fill="#575a89"
    />
    <ellipse cx="444" cy="675.26308" rx="444" ry="15.34206" fill="#d0cde1" />
    <path
      d="M844.634,746.20207a38.40966,38.40966,0,0,0-3.32864-15.9369A38.17241,38.17241,0,0,0,830,743.093a38.17229,38.17229,0,0,0-11.30538-12.82778,38.40966,38.40966,0,0,0-3.32864,15.9369A38.45748,38.45748,0,0,0,800,741.46679s1.01186,12.39687,9.29613,20.46128c7.36591,7.17041,18.00047,8.50131,20.26789,8.70829l.06349.04333.0173-.03616c.23011.02009.35519.02706.35519.02706s-.01926-.23439-.07345-.65746c.02333-.0545.04792-.11256.07345-.17333.02554.06078.05012.11883.07346.17334-.0542.42306-.07346.65745-.07346.65745s.12508-.007.35519-.02706l.0173.03616.06349-.04333c2.26741-.207,12.902-1.53787,20.26789-8.70829C858.98814,753.86366,860,741.46679,860,741.46679A38.45748,38.45748,0,0,0,844.634,746.20207Z"
      transform="translate(-156 -104.69743)"
      fill={mainColor}
    />
    <path
      d="M854.45162,160.793l.04763-.00816-6.992-40.87642-38.663,12.28283,5.78484,36.56086a9.93467,9.93467,0,1,0,3.9919,4.90622l.03551-.00561-6.20829-39.23624,32.515-10.32968,5.5272,32.31292a9.91405,9.91405,0,1,0,3.96119,4.39328Z"
      transform="translate(-156 -104.69743)"
      fill={mainColor}
    />
    <path
      d="M1039.55065,176.43494l.04762-.00816-6.992-40.87642-38.663,12.28283,5.78484,36.56086a9.93471,9.93471,0,1,0,3.99189,4.90623l.03552-.00562-6.2083-39.23624,32.51506-10.32968,5.52719,32.31292a9.914,9.914,0,1,0,3.9612,4.39328Z"
      transform="translate(-156 -104.69743)"
      fill={mainColor}
    />
    <path
      d="M907.25257,205.76582l.02755-.00435-4.9812-31.48107-2.46.38915,4.31829,27.29205a7.70307,7.70307,0,1,0,3.09536,3.80422Z"
      transform="translate(-156 -104.69743)"
      fill={mainColor}
    />
    <path
      d="M949.51189,166.68124a7.689,7.689,0,1,0-3.5865,6.48514l-4.3183,27.292,2.46.38915,4.9812-31.48114-.02756-.00434A7.63758,7.63758,0,0,0,949.51189,166.68124Z"
      transform="translate(-156 -104.69743)"
      fill={mainColor}
    />
    <polygon
      points="473.448 554.881 488.023 576.744 509.886 559.74 495.311 541.52 473.448 554.881"
      fill="#ffb8b8"
    />
    <path
      d="M646.83879,669.7106s-20.8743.97029-14.9902,12.00457,10.47435,73.29644,27.26835,69.68887,32.02057-22.69049,31.834-35.82712-2.28893-18.83415-2.28893-18.83415-4.50326-8.69557-1.50522-11.09648,4.1301-17.5777-3.01044-22.19295S656.36785,652.73,656.36785,652.73,654.27791,671.62637,646.83879,669.7106Z"
      transform="translate(-156 -104.69743)"
      fill="#2f2e41"
    />
    <polygon
      points="501.384 605.895 496.525 632.616 522.032 635.045 522.032 614.397 501.384 605.895"
      fill="#ffb8b8"
    />
    <path
      d="M605.15581,348.63984s-13.36065,44.94036-17.00447,71.66166c0,0-72.87626,98.383-59.51561,140.89411s52.228,127.53347,52.228,127.53347,65.58864-26.7213,78.94929-41.29655l-48.58418-69.23245s7.28763-8.50223-3.64381-13.36065-1.21461-10.93144-1.21461-10.93144,20.64828-69.23245,41.29655-76.52008l71.66166-14.57525s-4.85842-103.24138-21.86288-121.46045C697.46574,341.35221,612.44343,342.56682,605.15581,348.63984Z"
      transform="translate(-156 -104.69743)"
      fill="#2f2e41"
    />
    <path
      d="M663.45682,726.38182s-12.146-17.00447-18.21907-6.073S589.366,768.893,601.512,781.039s36.43814,14.57525,47.36958,7.28762,14.57525-12.146,14.57525-12.146,4.85842-8.50223,8.50223-7.28763,17.00446-6.073,17.00446-14.57525-6.073-29.15051-6.073-29.15051S665.886,733.66944,663.45682,726.38182Z"
      transform="translate(-156 -104.69743)"
      fill="#2f2e41"
    />
    <path
      d="M645.23775,468.88568l17.00446,146.96713s-9.71683,41.29655-12.146,72.87627,0,30.36511,0,30.36511,54.6572,21.86288,64.374,7.28763,4.85842-263.56916,4.85842-263.56916l-29.1505-26.7213Z"
      transform="translate(-156 -104.69743)"
      fill="#2f2e41"
    />
    <path
      d="M615.58635,140.78914c12.60928-29.75165,44.707-35.37054,44.707-35.37054s30.90545-8.2449,56.71559,31.02107c24.05712,36.59912,55.08021,70.88925,15.73675,85.49774l-10.3926-21.82606-1.24675,25.11827a160.17971,160.17971,0,0,1-17.3201,2.62842c-43.63952,4.43335-84.77656,11.80475-85.53844-3.96629C617.235,202.92639,603.4537,169.41618,615.58635,140.78914Z"
      transform="translate(-156 -104.69743)"
      fill="#2f2e41"
    />
    <circle cx="511.10063" cy="59.32254" r="35.22353" fill="#ffb8b8" />
    <path
      d="M656.77649,186.49015s-.6073,35.83083-4.25111,44.33306,64.98134-6.68032,64.98134-6.68032-24.29209-17.00446-27.93591-40.082Z"
      transform="translate(-156 -104.69743)"
      fill="#ffb8b8"
    />
    <path
      d="M662.24221,216.248l-6.6331-4.87866-46.80949,2.44945-9.71684,106.88519s-27.9359,32.79432,6.073,32.79432,65.58864-15.78986,89.88072-4.85842S739.9769,233.25242,739.9769,233.25242L703.664,211.3693S687.74891,230.82321,662.24221,216.248Z"
      transform="translate(-156 -104.69743)"
      fill="#575a89"
    />
    <path
      d="M622.16027,302.48487l68.01785,14.57526V332.85l-68.01785,2.42921S614.87264,307.34329,622.16027,302.48487Z"
      transform="translate(-156 -104.69743)"
      fill="#ffb8b8"
    />
    <path
      d="M622.16027,219.89177l-13.36065-6.073s-15.78986,3.64381-17.00446,17.00446-24.29209,99.59756-6.073,103.24138,42.51115,3.64381,42.51115,3.64381-15.78986-21.86288,3.64381-34.00892l-14.57525-7.28763s-14.57525-32.79432-4.85842-49.79878S622.16027,219.89177,622.16027,219.89177Z"
      transform="translate(-156 -104.69743)"
      fill="#575a89"
    />
    <polygon
      points="466.716 25.283 498.883 8.433 543.306 15.326 552.496 55.919 529.618 55.039 523.226 40.126 523.226 54.793 512.67 54.387 506.542 30.644 502.713 55.919 465.184 55.153 466.716 25.283"
      fill="#2f2e41"
    />
    <ellipse cx="546.52662" cy="55.88804" rx="6.47786" ry="11.33626" fill="#ffb8b8" />
    <circle cx="547.14923" cy="59.49231" r="4.42089" fill="#fff" />
    <ellipse cx="549.04748" cy="58.82659" rx="0.71865" ry="2.15595" fill="#2f2e41" />
    <path
      d="M704.93305,177.0218h0a1.131,1.131,0,0,1-1.131-1.131l-1.131-9.04832h3.39312v9.04832A1.131,1.131,0,0,1,704.93305,177.0218Z"
      transform="translate(-156 -104.69743)"
      fill="#fff"
    />
    <polygon
      points="460.723 148.149 449.254 197.85 476.016 197.85 454.989 193.071 460.723 148.149"
      opacity="0.1"
    />
    <path
      d="M754.89425,334.94933l-.25428-.22917,6.27805-6.966a5.42748,5.42748,0,0,0-.39814-7.66529L745.76157,306.788a5.42746,5.42746,0,0,0-7.66528.39813l-34.44188,38.21576a5.42747,5.42747,0,0,0,.39814,7.66529l14.75831,13.30089a5.42746,5.42746,0,0,0,7.66528-.39813l23.695-26.29132.25428.22917Z"
      transform="translate(-156 -104.69743)"
      fill="#3f3d56"
    />
    <circle cx="587.31626" cy="219.89765" r="3.49759" fill={mainColor} />
    <path
      d="M719.06276,322.48677s41.40429,10.02128,31.86466,24.30946-47.20249-11.8275-47.20249-11.8275Z"
      transform="translate(-156 -104.69743)"
      fill="#ffb8b8"
    />
    <path
      d="M729.04546,233.25242H739.9769s12.146,13.36065,9.71683,25.50669-9.71683,69.23246-9.71683,69.23246-36.43814,34.00892-54.6572,15.78985-4.85842-35.22353-4.85842-35.22353,24.29209,19.43368,37.65274-6.073Z"
      transform="translate(-156 -104.69743)"
      fill="#575a89"
    />
    <path
      d="M718.182,316.06261l8.36576-82.65247s17.54742-52.17864.418-53.45749-18.33264,49.44478-18.33264,49.44478l-29.83367,90.44266S695.17162,335.87583,718.182,316.06261Z"
      transform="translate(-156 -104.69743)"
      fill="#ffb8b8"
    />
  </svg>
);

export default SvgAudio;
